import {REDEMPTION_SUMMARY} from '../actions/const';

import moment from 'moment';

const initialState = {
  limit: 10,
  totalRecord: '',
  tableData: [],
  filterNid: null,
  filterCouponName: null
};

function reducer (state = initialState, action) {
  let {type, payload} = action;

  switch (type) {
    case REDEMPTION_SUMMARY:
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/RedemptionSummary.js